import { Injectable } from '@angular/core';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';
import type { CreditDebitExclusionFindInterface } from '@zaoblako/shared/modules/document/dtos/credit-debit/credit-debit-exclusion-find.dto';
import type { WithDeletedQueryInterface } from '@zaoblako/shared/common/dtos/with-deleted-query.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DebtsExclusionService extends BaseService {
  protected baseUrl = '/debts/debit-credit/exclusion';

  public getExclusions(queryParams?: WithDeletedQueryInterface): Observable<CreditDebitExclusionFindInterface[]> {
    return this.http.get<CreditDebitExclusionFindInterface[]>(`${this.baseUrl}`, {
      params: queryParams as any
    });
  }

  public getHistory(
    exclusionId: number,
    params: PaginationQueryInterface
  ): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${exclusionId}/history`, {
      params: this.objectToHttpParams(params)
    });
  }
}
